<template>
<div style="margin: 10px" class="container-fluid">
    <div class="row">
        <!-----------------------------------------------------------------------------------------------
    MODAL EDIT
    -------------------------->
        <b-modal ref="edit-modal" hide-footer hide-header title="Edit Item">
            <div style="padding: 0">
                <div style="margin: 10px 0">
                    <h4 class="service_txt">Edit Item</h4>
                </div>
                <hr>
                <form data-parsley-validate novalidate @submit.prevent>
                    <div class="">
                        <label class="label_add" for="userName">Item Name</label>
                        <input type="text" n parsley-trigger="change" required placeholder="Enter service name" class="input_add" v-model="selectedRows.itemName">
                    </div>
                    <div style="margin-top: 20px; margin-bottom: 20px" class="">
                        <label class="label_add" for="userName">Item Description</label>
                        <textarea type="text" parsley-trigger="change" required placeholder="Enter service description" class="input_add2" v-model="selectedRows.itemDescription"></textarea>
                    </div>
                    <div style="text-align: right" class="">
                        <button class="btn_add" type="submit" @click="editItems(selectedRows.itemId)">
                            Edit Item
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>

        <!-----------------------------------------------------------------------------------------------
    MODAL EDIT ends
    -------------------------->
        <!-----------------------------------------------------------------------------------------------
    MODAL DELETE
    -------------------------->
        <b-modal ref="item-modal-delete" hide-footer hide-header title="Edit Item">
            <div style="padding: 0">
                <div style="margin: 10px 0">
                    <h4 class="service_txt">Delete Item</h4>
                </div>
                <hr>
                <form data-parsley-validate novalidate @submit.prevent>
                    <div class="">
                        <label class="label_add" for="userName">Item Name</label>
                        <input type="text" n parsley-trigger="change" readonly required placeholder="Enter service name" class="input_add" v-model="selectedRows.itemName">
                    </div>
                    <div style="margin-top: 20px; margin-bottom: 20px" class="">
                        <label class="label_add" for="userName">Item Description</label>
                        <textarea type="text" parsley-trigger="change" readonly required placeholder="Enter service description" class="input_add2" v-model="selectedRows.itemDescription"></textarea>
                    </div>
                    <div style="text-align: right" class="">
                        <button class="btn_add" type="submit" @click="deleteItem(selectedRows.itemId)">
                            Delete Item
                        </button>
                    </div>
                </form>
            </div>
        </b-modal>

        <!-----------------------------------------------------------------------------------------------
    MODAL DELETE ends
    -------------------------->

        <!-----------------------------------------------------------------------------------------------
    ITEM CREATE
    -------------------------->
        <div class="container">
            <div class="row">
                <h4 class="service_txt mt-0 mb-3">Items</h4>
                <div style="margin-top: 20px;" class="col-lg-5">
                    <div class="document_div">
                        <h4 class="txt_add mb-3">Add Item</h4>
                        <div class="">
                            <form data-parsley-validate novalidate @submit.prevent>
                                <div class="">
                                    <label class="label_add" for="userName">Item Name</label>
                                    <input class="input_add" type="text" n parsley-trigger="change" required placeholder="Enter service name" v-model="newitemName">
                                </div>
                                <div style="margin-top: 20px" class="">
                                    <label class="label_add" for="userName">Item Description</label>
                                    <textarea class="input_add2" type="text" parsley-trigger="change" required placeholder="Enter service description" v-model="newitemDescription"></textarea>
                                </div>
                                <div style="margin-top: 20px; text-align: right">
                                    <button class="btn_add" type="submit" @click="addItems()">
                                        Add Item
                                    </button>
                                </div>
                            </form>
                        </div>
                        <!-- end col -->
                    </div>
                </div>
                <!-- end col -->

                <!-----------------------------------------------------------------------------------------------ITEM CREATE ENDS-------------------------->
                <div style="margin-top: 20px;" class="col-lg-7">
                    <div v-if="rows.length" class="table_add">
                        <h4 style="margin-left: 40px" class="txt_add mb-3">List of Items</h4>
                        <vue-bootstrap4-table :rows="rows" :columns="columns" :config="config">
                            <template slot="empty-results">
                                No Item found
                            </template>
                            <template slot="id" slot-scope="props">
                                <span>
                                    {{props.row.vbt_id}}
                                </span>
                            </template>
                            <template slot="itemName" slot-scope="props">
                                <span>
                                    {{props.cell_value}}
                                </span>
                            </template>
                            <template slot="itemId" slot-scope="props">
                                <span>
                                    {{props.cell_value}}
                                </span>
                            </template>
                            <template slot="action" slot-scope="props">
                                <!-- <span>
                                    <a @click="editItem(props.row)" class="btn btn-primary btn-xs" style="font-size:10px; color:#fff;">Edit</a>
                                </span> -->
                                <b-button class="btn_edit" @click="editItem(props.row)" id="show-btn">Setting</b-button>
                                <b-button class="btn_edit2" @click="deleteItemModal(props.row)" id="show-btn">Delete</b-button>
                            </template>
                        </vue-bootstrap4-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
// @ is an alias to /src

///////// IMPORT COOKIE SERVICE
import cookieOps from "@/services/cookieOps.js";
/////////////////////////
import router from '@/router/index'
///////// IMPORT COOKIE SERVICE

import VueBootstrap4Table from 'vue-bootstrap4-table'

import httpRequest from "@/services/httpRequests.js";
export default {
    name: 'items',
    components: {
        VueBootstrap4Table
    },
    data() {
        return {
            newitemName: '',
            newitemDescription: '',
            selectedRows: [],
            columns: [{
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Item Name",
                    name: "itemName",
                    //   slot_name: "stateName",
                    sort: false,
                },
                {
                    label: "Item Id",
                    name: "itemId",
                    sort: false,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action",
                }

            ],
            newbuild: [],
            rows: [],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: false,
                rows_selectable: false,
                selected_rows_info: false,
                card_title: "List of Documents",
                global_search: {
                    placeholder: "Search Documents",
                    visibility: false,
                    case_sensitive: false,
                },
                pagination: true, // default true
                pagination_info: false, // default true
                num_of_visibile_pagination_buttons: 7, // default 5
                per_page: 5, // default 10
                per_page_options: [5, 10, 20, 30],
            },

        };
    },

    beforeRouteEnter(to, from, next) {
        const fetch = httpRequest.get('item/all').then(function (res) {
            next(vm => vm.setData(res))
        })
    },

    mounted() {
        console.log(this.selectedRows)
    },

    /// SCOPE METHODS
    methods: {

        editItem(cell_value) {
            console.log(cell_value);
            this.$refs['edit-modal'].show()
            this.selectedRows = cell_value
        },

        deleteItemModal(cell_value) {
            console.log(cell_value);
            this.$refs['item-modal-delete'].show()
            this.selectedRows = cell_value
        },
        //////// sweet allert serivice
        alertDisplay(w, x, y) {
            // $swal function calls SweetAlert into the application with the specified configuration.
            this.$swal(w, x, y);
        },

        setData(data) {
            let allItems = httpRequest.detokenizeData(data.data.dataToken)
            console.log(allItems);
            this.rows = allItems.data
        },

        addItems() {
            let thiss = this
            const createItem = httpRequest.post('item/create', {
                'itemName': this.newitemName,
                'itemDescription': this.newitemDescription
            }).then(function (res) {
                if (res.data.code == 's200') {
                    thiss.newbuild.itemName = thiss.newitemName;
                    thiss.newbuild.itemId = '20000';
                    thiss.newbuild.deletedStatus = '0';
                    thiss.newbuild.slug = thiss.newitemName;
                    thiss.newbuild.suspendStatus = '0';
                    thiss.rows.push(thiss.newbuild)
                    // console.log(thiss.rows);
                    thiss.alertDisplay('Item Created', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Item Not Created', res.data.message, 'error');
                }
            })
        },
        deleteItem() {
            let thiss = this
            const itemId = this.selectedRows.itemId;
            const deleteItem = httpRequest.put(`item/delete/${itemId}`, {}).then(function (res) {
                console.log('RESPONSE', res)
                if (res.data.code == 's200') {
                    thiss.alertDisplay('Item Deleted', res.data.message, 'success');
                } else {
                    thiss.alertDisplay('Item Not Deleted', res.data.message, 'error');
                }
            })
            console.log('Jeg');
            console.log(this.selectedRows);
            this.$refs['item-modal-delete'].hide();
        },
        // EDIT ITEM
        editItems() {
            const itemId = this.selectedRows.itemId;
            const editItem = httpRequest.put(`item/edit/${itemId}`, {
                'itemName': this.selectedRows.itemName,
                'itemDescription': this.selectedRows.itemDescription
            }).then(function (res) {
                console.log('RESPONSE', res)
                if (res.data.code == 's200') {
                    this.newbuild.itemName = this.selectedRows.itemName;
                    this.newbuild.itemDescription = this.selectedRows.itemDescription;
                    this.newbuild.itemId = '20000';
                    this.newbuild.deletedStatus = '0';
                    this.newbuild.slug = this.newitemName;
                    this.newbuild.suspendStatus = '0';
                    this.rows.push(thiss.newbuild)
                    console.log(userLastCount());
                    this.alertDisplay('Service Edited', res.data.message, 'success');
                } else {
                    this.alertDisplay('Service Not Edited', res.data.message, 'error');
                }
            })
            this.$refs['edit-modal'].hide();
        },
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

.service_txt {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

a {
    text-decoration: none;
}

.btn_edit {
    width: auto;
    height: auto;
    padding: 10px;
    background: #E9F0FF;
    margin: 5px 0;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1A87CA;
}

.btn_edit2 {
    width: auto;
    height: auto;
    padding: 10px;
    background: #ab3b48;
    margin: 5px 5px;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #E9F0FF;
}

.btn_edit:hover {
    width: auto;
    height: auto;
    padding: 10px;
    background: #E9F0FF;
    margin: 5px 0;
    cursor: pointer;
    border: none;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #1A87CA;
}

.btn_add {
    /* padding: 20px; */
    border: none;
    width: 150px;
    height: 50px;
    background: #555A6E;
    border-radius: 4px;

    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #FFFFFF;

}

.txt_add {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    display: flex;
    align-items: center;
    color: #494949;
}

template {
    position: relative;
    min-height: 100%;
}

.card-header {
    font-weight: 600 !important;
    background-color: red;
}

body {
    padding-bottom: 60px;
    overflow-x: hidden;
}

.authentication-bg.enlarged {
    min-height: 100px;
}

.document_div {
    width: 100%;
    height: 407px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px 40px;
}

.document_div2 {
    width: 100%;
    height: auto;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px 10px;
}

body.authentication-bg {
    background-image: url(../../assets/bg-light-img.jpg);
    background-size: cover;
    background-position: center;
}

.input_add {
    padding: 20px;
    width: 100%;
    height: 55px;

    background: #FFFFFF;
    border: 0.5px solid #D3D8DD;
    box-sizing: border-box;
    border-radius: 4px;
}

.table_add {
    width: 100%;
    height: auto;
    padding: 20px 0;
    background: #FFFFFF;
    border-radius: 4px;
}

.input_add2 {
    padding: 20px;
    width: 100%;
    height: 87px;
    background: #FFFFFF;
    border: 0.5px solid #D3D8DD;
    box-sizing: border-box;
    border-radius: 4px;
}

.label_add {
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 115.5%;
    display: flex;
    align-items: center;
    color: #494949;
    margin-bottom: 10px;
}
</style>
